'use client';

import { useSyncExternalStore } from 'react';

import {
  getServerSiteFailure,
  getSiteFailure,
  subscribeToSiteFailure,
} from '@/lib/site-failure-store';

export const useSiteFailure = () =>
  useSyncExternalStore(
    subscribeToSiteFailure,
    getSiteFailure,
    getServerSiteFailure
  );
